import { __objRest, __spreadProps, __spreadValues } from './chunk-3TCQU24P.mjs';
import { jsx } from 'react/jsx-runtime';

var Button = (_a) => {
  var _b = _a, {
    fullWidth = false,
    structure = "base",
    disabled = false,
    onClick,
    children,
    className
  } = _b, props = __objRest(_b, [
    "fullWidth",
    "structure",
    "disabled",
    "onClick",
    "children",
    "className"
  ]);
  const getButtonClasses = () => {
    if (disabled) {
      switch (structure) {
        case "outlined":
          return "ui-bg-transparent ui-border ui-border-neutral-600 ui-text-neutral-600 ui-pointer-events-none";
        case "naked":
          return "ui-border-none ui-bg-transparent ui-text-white/60 ui-underline ui-font-normal ui-pointer-events-none";
        case "destructive":
          return "ui-bg-red-500/60 ui-text-white hover:ui-bg-red-600 ui-pointer-events-none";
        default:
          return "ui-bg-white/60 ui-text-black ui-pointer-events-none";
      }
    }
    switch (structure) {
      case "outlined":
        return "ui-border ui-bg-transparent ui-border-neutral-300 ui-border-opacity-50 ui-text-white hover:ui-bg-white/5";
      case "naked":
        return "ui-border-none ui-bg-transparent ui-text-white ui-underline ui-font-normal";
      case "destructive":
        return "ui-bg-red-500 ui-text-white hover:ui-bg-red-400";
      case "destructive-outline":
        return "ui-border ui-border-red-500 ui-bg-transparent ui-text-red-500 hover:ui-bg-red-500/5";
      default:
        return "ui-bg-white ui-text-black hover:ui-bg-neutral-100";
    }
  };
  return /* @__PURE__ */ jsx(
    "button",
    __spreadProps(__spreadValues({
      className: `ui-flex ui-items-center ui-justify-center ui-rounded-md ui-font-akkuratLL ui-uppercase ui-px-5 ui-py-3.5 ui-text-sm ui-outline-none ui-hover:opacity-70 ${fullWidth ? "ui-w-full" : ""} ${getButtonClasses()} ${className}`,
      onClick
    }, props), {
      children
    })
  );
};

export { Button };
